import { z } from "zod";

// Request de paginación base
export const PaginationRequestSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().positive().max(100).default(10),
});

export type PaginationRequestDTO = {
  page: number;
  pageSize: number;
  [key: string]: any;
};

// Alias para compatibilidad
export type FlatPaginationRequestDTO<T extends Record<string, any> = Record<string, any>> = PaginationRequestDTO & T;

// Response de paginación genérico
export const PaginationResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    data: z.array(itemSchema),
    pagination: z.object({
      page: z.number(),
      pageSize: z.number(),
      total: z.number(),
      totalPages: z.number(),
    }),
  });

export type PaginationResponseDTO<T> = {
  data: T[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
};

// ======================
// CURSOR PAGINATION
// ======================
export const CursorPaginationRequestSchema = z.object({
  pageSize: z.coerce.number().int().positive().max(100).default(10),
  cursorDate: z.string().nullable().optional(),
  cursorId: z.string().nullable().optional(),
  direction: z.enum(["forward", "backward"]).optional().default("forward"),
  pastCount: z.coerce.number().int().min(0).optional(),
  initialLoad: z.preprocess((value) => {
  if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  }, z.boolean().optional()),
});

export type CursorPaginationRequestDTO = {
  pageSize: number;
  cursorDate?: string | null;
  cursorId?: string | null;
  direction?: "forward" | "backward";
  pastCount?: number;
  initialLoad?: boolean;
  [key: string]: any;
};

export const CursorPaginationResponseSchema = <T extends z.ZodTypeAny>(
  itemSchema: T,
) =>
  z.object({
    data: z.array(itemSchema),
    pagination: z.object({
      pageSize: z.number(),
      hasNext: z.boolean(),
      hasPrev: z.boolean(),
      nextCursor: z
        .object({
          cursorDate: z.string().nullable(),
          cursorId: z.string(),
        })
        .nullable(),
      prevCursor: z
        .object({
          cursorDate: z.string().nullable(),
          cursorId: z.string(),
        })
        .nullable(),
    }),
  });

export type CursorPaginationResponseDTO<T> = {
  data: T[];
  pagination: {
    pageSize: number;
    hasNext: boolean;
    hasPrev: boolean;
    nextCursor: {
      cursorDate: string | null;
      cursorId: string;
    } | null;
    prevCursor: {
      cursorDate: string | null;
      cursorId: string;
    } | null;
  };
};